import { CSSProperties } from 'react';
import { Color, Size } from '@vivli/shared/theme';

interface AmrAdminHeaderTitleProps {
    title: string;
    style?: CSSProperties;
}

const titleStyle: CSSProperties = {
    fontSize: 22,
    fontWeight: Size.FontWeight.Regular,
    color: Color.DARK_GRAY,
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    minWidth: 0,
    flex: 1,
    lineHeight: 1.2,
};

export const AmrAdminHeaderTitleView = ({ title, style }: AmrAdminHeaderTitleProps) => (
    <div style={{ ...titleStyle, ...style }} title={title}>
        {title}
    </div>
);
